import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

var cubicBezierAsString = function cubicBezierAsString(_ref) {
  var _ref2 = _slicedToArray(_ref, 4),
      a = _ref2[0],
      b = _ref2[1],
      c = _ref2[2],
      d = _ref2[3];

  return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};

export { cubicBezierAsString };